<template>
  <div class="w-100">
    <div class="col-12 d-flex mt-2  justify-content-center" v-if="loader">
      <div class="spinner-border text-primary"></div>
    </div>
   <template v-if="!loader">
     <div class="col-12" v-show="typeof(hidePaymentMethodDropdown) == 'undefined'?true:false">
       <div class="form-group row">
         <div class="col-sm-3 col-form-label">
           <label>Payment Method </label>
         </div>
         <div class="col-sm-9">
           <div class="input-group">
             <b-form-select
                 v-model="paymentId"
                 name="paymentId"
                 size="sm"
                 class=""
                 v-validate="'required'"
                 :class="
                                  errorBag.has('paymentId') ? 'is-invalid' : ''
                                "
             >
               <b-form-select-option value=""
               >Please Select payment Method
               </b-form-select-option>
               <b-form-select-option
                   v-for="(item, index) in paymentMethodRequestData"
                   :value="item.id"
                   :key="index"
               >{{ item.name }}
               </b-form-select-option>
               <b-form-select-option
                   v-show="
                                    !paymentMethodRequestData
                                  "
                   value="Please Select Payment Method"
               ></b-form-select-option>
             </b-form-select>
             <small
                 v-show="errorBag.has('paymentId')"
                 class="invalid-feedback"
             >{{ "*" + errorBag.first("paymentId") }}</small
             >
           </div>
         </div>
       </div>
     </div>
     <slot></slot>
     <div class="col-12" v-if="(allFieldsCodes.includes(code)) && !clear" :key="rerender">
       <div class="card">
         <div class="card-header">
           <h4 class="card-title">Settings <button type="button" class="btn btn-sm btn-warning" @click="clear = true">clear</button></h4>
         </div>
         <div class="card-body">

           <div class="row">
             <div class="col-12" >
               <div class="form-group ">
                 <div class="col-12">
                   <div class="added-field">
                     <div class="col-12">
<!--                       <div class="form-group row">-->
<!--                         <div-->
<!--                             class="col-sm-3 col-form-label text-right"-->
<!--                         >-->
<!--                           <label >Bypass3DS</label>-->
<!--                         </div>-->
<!--                         <div class="col-sm-9">-->
<!--                           <div class="">-->
<!--                             <input-->
<!--                                 class="custom-checkbox form-control "-->
<!--                                 style="margin-top: 0.7rem;"-->
<!--                                 type="checkbox"-->
<!--                                 @change="emitObject"-->
<!--                                 v-model="allSettings[code].Bypass3DS"-->

<!--                             />-->
<!--                           </div>-->
<!--                         </div>-->
<!--                       </div>-->
                     </div>

                     <div class="col-12" v-for="(set3Item, set3Index) in [...allTempSettings[code] || [], ...allTempSettings['GENERAL'] || []]">
<!--                     <div class="col-12" v-for="(set3Item,set3Index) in allTempSettings[code]">-->
                       <div class="form-group row">
                         <div
                             class="col-sm-3 col-form-label text-right"
                         >
                           <label>{{set3Item.field}}</label>
                         </div>
                         <div class="col-sm-9">
                           <div class="input-group">
                             <v-select
                                 v-if="set3Item.type === 'dropdown'"
                                 v-model="allSettings[code][set3Item.name]"
                                 :options="set3Item.options || []"
                                 label="value"
                                 :searchable="true"
                                 :clearable="true"
                             />
                             <v-select
                                 v-else-if="set3Item.type === 'countryDropdown'"
                                 v-model="allSettings[code][set3Item.name]"
                                 :options="countryData().map(item => ({ label: item.name, value: item.code }))"
                                 label="label"
                                 :reduce="option => option.value"
                                 :searchable="true"
                                 :clearable="true"
                             />
                             <input
                                 v-else
                                 :type="set3Item.type"
                                 v-model="allSettings[code][set3Item.name]"
                                 class="form-control"
                                 :name="set3Item.name"
                                 @change="emitObject"
                                 :class="
                                  errorBag.has(set3Item.name) ? 'is-invalid' : ''
                                "
                             />
                             <small
                                 v-show="errorBag.has(set3Item.name)"
                                 class="invalid-feedback"
                             >{{ "*" + errorBag.first(set3Item.name) }}</small>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>

         </div>
       </div>
     </div>
   </template>
  </div>
</template>

<script>
import {countryData} from "../../assets/CountryData";
export default {
  props: ['modelValue','hidePaymentMethodDropdown'],
  mounted() {
    this.getPaymentFields()
    this.tempModalValue = this.modelValue

  },
  data() {
    return {
      code: "",
      paymentId: "",
      paymentMethodRequestData: [],
      chargeTypeOption:[],
      tempModalValue:{},
      loader:false,
      clear:false,
      rerender:0,
      allSettings:{},
      allTempSettings:{},
      allFieldsCodes:[]
    };
  },
  methods: {
    countryData() {
      return countryData
    },
    emitObject(){
      let data = {
        paymentId: this.paymentId,
        code: this.code,
        settings: {},
        validated:false,
        allFieldsCodes:this.allFieldsCodes
      }
      data.settings = this.allSettings[this.code]

      this.$validator.validateAll().then(valid => {
        data.validated = valid;
      })


      this.$emit('update:modelValue', data)
    },
    getPaymentFields(){
      this.rerender = Math.random()
      this.loader = true
      this.makeRequest("post", "v1/get-charges-types-data", {}, {}, false,true,[205]).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.chargeTypeOption = data.paymentMethodsData
                }
                this.allFieldsCodes = Object.keys(this.chargeTypeOption);


                if(this.allFieldsCodes){
                  this.allFieldsCodes.forEach(eachCode => {
                    // let deepCloneObject = {Bypass3DS:false}
                    let deepCloneObject = {};
                    var tempSetting2 = this.chargeTypeOption[eachCode]
                    tempSetting2.forEach(eachFeature => {

                      deepCloneObject[eachFeature.name] = ''
                    })
                    this.allSettings[eachCode] = JSON.parse(JSON.stringify(deepCloneObject))
                    this.allTempSettings[eachCode] = tempSetting2

                  })
                }

                if (data?.paymentMethodsData?.GENERAL) {
                  const generalSettings = {};
                  data?.paymentMethodsData?.GENERAL.forEach((feature) => {
                    generalSettings[feature.name] = feature.type === "dropdown" ? feature.options[0] : '';
                  });
                  this.allSettings.GENERAL = generalSettings;
                  this.allTempSettings.GENERAL = data?.paymentMethodsData?.GENERAL;
                }

                this.selectPaymentData()

              }
            }
          }
      );
    },
    selectPaymentData() {
      this.makeRequest("post", "v1/get-payment-method", {
        flag: "active"
      }, {},false,true,[205]).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = [];
            data = callResponse.response.data.data;
            this.paymentMethodRequestData = data

            if(typeof(this.tempModalValue.paymentId) != 'undefined'){
              this.paymentId = this.tempModalValue.paymentId
            }
            let payment = this.paymentMethodRequestData.find(item => item.id === this.tempModalValue.paymentId);
            if (payment) {
              this.code = payment.code;
            } else {
              this.code = "";
            }
            if(this.tempModalValue.settings){
              if(typeof(this.allSettings[this.code]) != 'undefined'){
                this.allSettings[this.code] = this.tempModalValue.settings
              }
            }



          }
        }
        this.loader = false
      });
    },
    validateAllFields(){
      return this.$validator
    }

  },
  watch:{
    paymentId(id){
      const payment = this.paymentMethodRequestData.find(item => item.id === id);
      if (payment) {
        this.code = payment.code;
      } else {
        this.code = "";
      }
      this.emitObject()
    },


  }
};
</script>

